import axiosInstance from 'config/axiosConfig';

export interface HuurayBalanceItem {
  Balance: number;
  Currency: string;
  Master: boolean;
}

export interface HuurayBalanceResponse {
  Balances: HuurayBalanceItem[];
  Status: number;
  Message: string;
}

export const getHuurayBalance = async (): Promise<HuurayBalanceResponse> => {
  const { data } = await axiosInstance().get('/getBalance');
  return data?.data || data;
};
